// 목록 표시용 개인정보 마스킹 유틸 (상세 화면은 원본 노출)

// 전화번호: 가운데 4자리 마스킹. 01012345678 → 010-****-5678
export function maskPhone(phone) {
  if (!phone) return '';
  const digits = String(phone).replace(/\D/g, '');
  if (digits.length < 7) return phone; // 비정상값은 그대로
  return `${digits.slice(0, 3)}-****-${digits.slice(-4)}`;
}

// 이메일(선택): 로컬파트 일부 마스킹. abcdef@x.com → ab****@x.com
export function maskEmail(email) {
  if (!email || !email.includes('@')) return email || '';
  const [local, domain] = email.split('@');
  const head = local.slice(0, 2);
  return `${head}${'*'.repeat(Math.max(2, local.length - 2))}@${domain}`;
}
